'use client';

import { PRIVACY_POLICY } from '@shared/constants';
import { PrivacyPolicyRenderer } from '../../components/legal/PrivacyPolicyRenderer';

/**
 * Privacy Policy page component
 * Displays comprehensive privacy policy from PRIVACY_POLICY constant
 */
export function PrivacyPage() {
  return (
    <div className="px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-4xl mx-auto">
        <PrivacyPolicyRenderer policy={PRIVACY_POLICY} />
      </div>
    </div>
  );
}
